import React from "react";
import { primaryColor, primaryTextColor, secondaryColor, bgColorOppositeShade } from "../../utils/constants";

export default function TeamChallenge({
  color = primaryColor,
  color2 = secondaryColor,
  color3 = primaryTextColor,
  color4 = bgColorOppositeShade,
}) {
  return (
    <svg version="1.1" id="Icon_Set" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 512 512">
      <style type="text/css"></style>
      <g>
        <g>
          <g>
            <g>
              <circle fill={color2} cx="256" cy="256" r="207" />
            </g>
          </g>
        </g>
        <g>
          <g>
            <g>
              <path
                fill={color}
                d="M32.488,365.693v-19.797c0-16.659,8.645-32.125,22.834-40.853l54.635-33.606h28.837l54.635,33.606
					c14.19,8.728,22.834,24.194,22.834,40.853v19.797H32.488z"
              />
            </g>
          </g>
        </g>
        <g>
          <g>
            <path
              fill={color}
              d="M193.421,305.043L184,299.091V366h32v-20.104C216,329.237,207.611,313.772,193.421,305.043z"
            />
          </g>
        </g>
        <g>
          <g>
            <g>
              <path
                fill={color3}
                d="M216.265,371.693H32.488c-3.313,0-6-2.686-6-6v-19.797c0-18.604,9.844-36.216,25.69-45.963l54.635-33.606
					c0.945-0.582,2.033-0.889,3.144-0.889h28.838c1.11,0,2.198,0.308,3.144,0.889l54.636,33.606
					c15.847,9.747,25.69,27.359,25.69,45.963v19.797C222.265,369.007,219.578,371.693,216.265,371.693z M38.488,359.693h171.776
					v-13.797c0-14.467-7.655-28.163-19.978-35.742l-53.189-32.717h-25.443l-53.188,32.717
					c-12.322,7.579-19.978,21.275-19.978,35.742V359.693z"
              />
            </g>
          </g>
        </g>
        <g>
          <g>
            <g>
              <path
                fill={color4}
                d="M124.376,292.243L124.376,292.243c-25.033,0-45.326-20.293-45.326-45.326v-30.954
					c0-25.033,20.294-45.327,45.326-45.327l0,0c25.033,0,45.327,20.293,45.327,45.327v30.954
					C169.703,271.95,149.409,292.243,124.376,292.243z"
              />
            </g>
          </g>
        </g>
        <g>
          <g>
            <g>
              <path
                fill={color3}
                d="M124.376,298.243c-28.302,0-51.326-23.025-51.326-51.326v-30.954c0-28.302,23.024-51.327,51.326-51.327
					c28.302,0,51.326,23.025,51.326,51.327v30.954C175.702,275.218,152.678,298.243,124.376,298.243z M124.376,176.636
					c-21.685,0-39.326,17.642-39.326,39.327v30.954c0,21.685,17.642,39.326,39.326,39.326c21.685,0,39.326-17.642,39.326-39.326
					v-30.954C163.702,194.278,146.061,176.636,124.376,176.636z"
              />
            </g>
          </g>
        </g>
        <g>
          <g>
            <g>
              <path
                fill={color}
                d="M295.735,365.693v-19.797c0-16.659,8.645-32.125,22.834-40.853l54.636-33.606h28.837l54.636,33.606
					c14.189,8.728,22.834,24.194,22.834,40.853v19.797H295.735z"
              />
            </g>
          </g>
        </g>
        <g>
          <g>
            <path
              fill={color}
              d="M456.421,305.043L447,299.091V366h32v-20.104C479,329.237,470.61,313.772,456.421,305.043z"
            />
          </g>
        </g>
        <g>
          <g>
            <g>
              <path
                fill={color3}
                d="M479.512,371.693H295.735c-3.314,0-6-2.686-6-6v-19.797c0-18.604,9.844-36.216,25.69-45.963l54.636-33.606
					c0.945-0.582,2.033-0.889,3.144-0.889h28.837c1.11,0,2.198,0.308,3.143,0.889l54.636,33.606
					c15.847,9.747,25.69,27.359,25.69,45.963v19.797C485.512,369.007,482.825,371.693,479.512,371.693z M301.735,359.693h171.776
					v-13.797c0-14.467-7.655-28.163-19.977-35.742l-53.19-32.717h-25.442l-53.189,32.717c-12.322,7.579-19.977,21.275-19.977,35.742
					V359.693z"
              />
            </g>
          </g>
        </g>
        <g>
          <g>
            <g>
              <path
                fill={color4}
                d="M387.623,292.243L387.623,292.243c-25.032,0-45.326-20.293-45.326-45.326v-30.954
					c0-25.033,20.294-45.327,45.326-45.327l0,0c25.033,0,45.327,20.293,45.327,45.327v30.954
					C432.95,271.95,412.656,292.243,387.623,292.243z"
              />
            </g>
          </g>
        </g>
        <g>
          <g>
            <g>
              <path
                fill={color3}
                d="M387.623,298.243c-28.302,0-51.326-23.025-51.326-51.326v-30.954c0-28.302,23.024-51.327,51.326-51.327
					c28.302,0,51.327,23.025,51.327,51.327v30.954C438.95,275.218,415.925,298.243,387.623,298.243z M387.623,176.636
					c-21.684,0-39.326,17.642-39.326,39.327v30.954c0,21.685,17.642,39.326,39.326,39.326c21.686,0,39.327-17.642,39.327-39.326
					v-30.954C426.95,194.278,409.309,176.636,387.623,176.636z"
              />
            </g>
          </g>
        </g>
        <g>
          <g>
            <g>
              <path
                fill={color}
                d="M163.988,366v-19.828c0-16.685,8.657-32.176,22.87-40.917l54.721-33.659h28.883l54.721,33.659
					c14.213,8.742,22.87,24.232,22.87,40.917V366H163.988z"
              />
            </g>
          </g>
        </g>
        <g>
          <g>
            <path
              fill={color}
              d="M325.411,304.947L316,298.986V366h32v-20.135C348,329.179,339.623,313.689,325.411,304.947z"
            />
          </g>
        </g>
        <g>
          <g>
            <g>
              <path
                fill={color3}
                d="M348.053,372H163.988c-3.313,0-6-2.686-6-6v-19.828c0-18.631,9.857-36.268,25.726-46.028l54.722-33.659
					c0.945-0.582,2.033-0.889,3.144-0.889h28.883c1.11,0,2.198,0.308,3.144,0.889l54.721,33.659
					c15.868,9.76,25.727,27.397,25.727,46.028V366C354.053,369.314,351.366,372,348.053,372z M169.988,360h172.064v-13.828
					c0-14.494-7.669-28.214-20.014-35.807l-53.275-32.77h-25.488l-53.275,32.77c-12.345,7.593-20.013,21.313-20.013,35.807V360z"
              />
            </g>
          </g>
        </g>
        <g>
          <g>
            <g>
              <path
                fill={color4}
                d="M256.02,292.434L256.02,292.434c-25.072,0-45.398-20.325-45.398-45.397v-31.003
					c0-25.072,20.326-45.398,45.398-45.398l0,0c25.073,0,45.397,20.325,45.397,45.398v31.003
					C301.418,272.109,281.093,292.434,256.02,292.434z"
              />
            </g>
          </g>
        </g>
        <g>
          <g>
            <g>
              <path
                fill={color3}
                d="M256.021,298.434c-28.341,0-51.398-23.057-51.398-51.398v-31.003c0-28.341,23.058-51.398,51.398-51.398
					s51.397,23.057,51.397,51.398v31.003C307.418,275.377,284.361,298.434,256.021,298.434z M256.021,176.636
					c-21.725,0-39.398,17.674-39.398,39.398v31.003c0,21.724,17.674,39.398,39.398,39.398c21.724,0,39.397-17.674,39.397-39.398
					v-31.003C295.418,194.309,277.744,176.636,256.021,176.636z"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}
